// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__mb_7g","buttons":"RemoveExpirationActionButtons_buttons__1NRnN"};